import React from 'react';
import './style.css';

function Loading() {
  return <div className="custom-loader" />;
}

export default Loading;
